import { logger } from '../../../../core/Log/logger';
import { PickDomain } from '../../../../shared/utilities/types/PickDomain';
import { Facet } from '../types/facet';

export function getFacetTagNameTrackingProperty({
    id,
    filter,
}: PickDomain<
    Facet,
    'filter',
    {
        id?: Facet['id'];
    }
>): string {
    if (filter.value === false) {
        logger.error('Facet filter should never be false', { id, filter });
    }
    if (typeof filter.value === 'boolean') {
        return filter.name;
    }
    return filter.value;
}
